import type { i18n } from 'i18next'
import { SUPPORTED_LANGUAGES } from 'src/constants/locale'
import { SupportedLanguages } from 'src/types/locale'

export const getCurrentLanguage = (
  i18nArgs: Pick<i18n, 'language' | 'resolvedLanguage'>,
): SupportedLanguages => {
  const language = i18nArgs.resolvedLanguage ?? i18nArgs.language

  if (language.startsWith(SUPPORTED_LANGUAGES.EN)) {
    return SUPPORTED_LANGUAGES.EN
  }

  if (language.startsWith(SUPPORTED_LANGUAGES.ES)) {
    return SUPPORTED_LANGUAGES.ES
  }

  return SUPPORTED_LANGUAGES.EN
}
